import React, {useState} from "react";
import {useSearchParams} from "react-router-dom";
import Loading from "./components/loading";
import {determineLocation} from "./assets/determineLocation";
import {Alert, AlertTitle, Container, Link} from "@mui/material";
import {DarkButton} from "./components/buttons";
import Receipt from "./Receipt";
import ResponsiveAppBar from "./components/responsive-app-bar";
import Spacer from "./components/Spacer";
import {RenewalStepFlowDisplay} from "./components/renewal-step-flow-display";
import Footer from "./components/home/Footer";
import Store from "./store";

const Complete = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    // Stripe returns payment_intent_client_secret for a payment, or setup_intent_client_secret for an early (pre-order) filing.
    const paymentSecret = searchParams.get("payment_intent_client_secret") ?? searchParams.get("setup_intent_client_secret");
    const [confirmed, setConfirmed] = useState(false);
    const [failed, setFailed] = useState(false);
    const [unpaid, setUnpaid] = useState(false);
    const [attempt, setAttempt] = useState(0);

    React.useEffect(() => {
        let active = true;
        setFailed(false);
        setUnpaid(false);
        (async () => {
            if (!paymentSecret) throw new Error("No payment to confirm.");
            const x = await fetch(`${determineLocation()}/billing/payment/complete/${encodeURIComponent(paymentSecret)}`, {method: 'POST'});
            const json = await x.json();
            // 402: the payment didn't go through (e.g. the bank's verification failed), so there is nothing to confirm.
            if (x.status === 402) {
                if (active) setUnpaid(true);
                return;
            }
            if (x.status !== 200 || typeof json?.message !== "string" || !json.message) throw new Error("Failed to get receipt.");
            if (!active) return;
            setSearchParams({receipt:json.message})
            window.history.replaceState(null, "Receipt", `/receipt?receipt=${json.message}`);
            setConfirmed(true)

            Store.setRenewStep(3)
        })().catch(error => {
            console.log("failed to get receipt", error);
            if (active) setFailed(true);
        });
        return () => { active = false; };
    }, [attempt]);

    if (unpaid) {
        return (<>
            <ResponsiveAppBar showLogin={false}/>
            <Container maxWidth={"sm"} sx={{py: 6}}>
                <Alert severity="error">
                    <AlertTitle>Your payment wasn't completed</AlertTitle>
                    Your card was not charged and no order was placed. Please go back to your filing link and try the payment
                    again, or use another card. If you need help, contact support
                    at <Link href="mailto:support@fcfiling.com">support@fcfiling.com</Link>.
                </Alert>
            </Container>
            <Spacer height={250}/>
            <Footer/>
        </>);
    }

    if (failed) {
        return (<>
            <ResponsiveAppBar showLogin={false}/>
            <Container maxWidth={"sm"} sx={{py: 6}}>
                <Alert severity="warning">
                    <AlertTitle>We couldn't load your order confirmation</AlertTitle>
                    If your payment went through, a confirmation email is on its way to you. Please check your inbox, including
                    the spam folder, before trying to pay again. If you don't receive it, contact support
                    at <Link href="mailto:support@fcfiling.com">support@fcfiling.com</Link> with your company name and we'll confirm your order.
                </Alert>
                {paymentSecret && <DarkButton variant="contained" disableElevation sx={{mt: 3}} onClick={() => setAttempt(value => value + 1)}>
                    Try loading the confirmation again
                </DarkButton>}
            </Container>
            <Spacer height={250}/>
            <Footer/>
        </>);
    }

    if (!confirmed) {
        return <Loading/>
    }

    return (<>
        <ResponsiveAppBar showLogin={false}/>
        <Container maxWidth={"md"}>
            <Spacer height={50}/>
            <RenewalStepFlowDisplay/>
            <Spacer height={20}/>
            <Receipt/>
        </Container>
        <Spacer height={250}/>
        <Footer/>

    </>);

}

export default Complete
